var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { MeAgentSDK } from "./sdk";
import { SupportedNetwork, Environment } from "./types";
let sdkInstance = null;
/**
 * Initialize the MeAgent SDK
 */
function init(config) {
    return __awaiter(this, void 0, void 0, function* () {
        if (sdkInstance) {
            console.warn("MeAgent: Instance already exists. Destroying previous instance.");
            destroy();
        }
        sdkInstance = new MeAgentSDK(config);
        yield sdkInstance.init();
    });
}
/**
 * Destroy the SDK instance
 */
function destroy() {
    if (sdkInstance) {
        sdkInstance.destroy();
        sdkInstance = null;
    }
}
/**
 * Open the chat widget programmatically
 */
function open() {
    if (sdkInstance) {
        sdkInstance.open();
    }
    else {
        console.warn("MeAgent: SDK not initialized. Call MeAgent.init() first.");
    }
}
/**
 * Close the chat widget programmatically
 */
function close() {
    if (sdkInstance) {
        sdkInstance.close();
    }
    else {
        console.warn("MeAgent: SDK not initialized. Call MeAgent.init() first.");
    }
}
/**
 * Toggle the chat widget programmatically
 */
function toggle() {
    if (sdkInstance) {
        sdkInstance.toggle();
    }
    else {
        console.warn("MeAgent: SDK not initialized. Call MeAgent.init() first.");
    }
}
/**
 * Update cart items dynamically
 */
function updateCartItems(cartItems) {
    if (sdkInstance) {
        sdkInstance.updateCartItems(cartItems);
    }
    else {
        console.warn("MeAgent: SDK not initialized. Call MeAgent.init() first.");
    }
}
/**
 * Update liked offers dynamically
 */
function updateLikedOffers(likedOffers) {
    if (sdkInstance) {
        sdkInstance.updateLikedOffers(likedOffers);
    }
    else {
        console.warn("MeAgent: SDK not initialized. Call MeAgent.init() first.");
    }
}
// Export for UMD build
const MeAgent = {
    init,
    destroy,
    open,
    close,
    toggle,
    updateCartItems,
    updateLikedOffers,
    Network: SupportedNetwork,
    Environment: Environment,
};
// For UMD build - attach to window
if (typeof window !== "undefined") {
    window.MeAgent = MeAgent;
}
export default MeAgent;
export { MeAgentSDK } from "./sdk";
export { SupportedNetwork, Environment, } from "./types";
